// 危险废物暂存
<template>
  <div class="mapwrap" v-if="isRefresh">
    <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" v-if="tabData.length>1" @tab-click="handleRefresh()" stretch>
        <el-tab-pane v-for="(tabDataItem, tabDataIndex) in tabData" :key="tabDataIndex"
          :label="tabDataItem.tabTitle" :name="tabDataItem.tabIndex"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- table -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'table'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="addRow">新增</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'table'">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{tri+1}}</td>
          <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button type="text" size="mini" @click="editRow(tr)">编辑</el-button>
            <el-button type="text" size="mini" @click="saveRow(tr)">保存</el-button>
            <el-button type="text" size="mini" @click="deleteRow(tr)">删除</el-button>
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
          </td>
        </tr>
      </table>
    </div>
    <!-- multiform -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'multiform'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="editForm()">编辑</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="saveForm()">保存</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'multiform'">
      <table class="listTable" width="100%" border="1" align="center">
        <!-- <tr>
          <th class="cell thtitle" width="25%" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
        </tr> -->
        <tr v-for="(tr, tri) in tabDataCrt.multiformData" :key="tri">
          <td class="cell tdcell" width="25%" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tabDataCrt.editable && !tr.editFlag && td !== 'name'" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index'
export default {
  data () {
    return {
      tabType: 'tabA',
      companyName: '',
      // tabData
      tabData: [
        {
          tabTitle: '危险废物暂存间环保手续-应急预案',
          tabIndex: 'tabA',
          tabType: 'table',
          tableNames: [
            '预案名称',
            '编制单位',
            '有效期（开始）',
            '有效期（截止）',
            '备案单位',
            '备案时间'
          ],
          rowItems: [
            'planName',
            'preSheetName',
            'startDate',
            'endDate',
            'filingUnit',
            'filingTime'
          ],
          api: {
            add: 'hbContingencyPlanAdd',
            enquiry: 'hbContingencyPlanEnquiry',
            update: 'hbContingencyPlanUpdate',
            delete: 'hbContingencyPlanDelete',
            extraParam: {
              category: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '危险废物暂存间规范性',
          tabIndex: 'tabB',
          tabType: 'table',
          tableNames: [
            '标识标牌',
            '双人双锁',
            '监控导流槽',
            '收集池',
            '通风'
          ],
          rowItems: [
            'signage',
            'doubleLock',
            'launder',
            'collectionPool',
            'ventilate'
          ],
          api: {
            add: 'hbContingencyPlanAdd',
            enquiry: 'hbContingencyPlanEnquiry',
            update: 'hbContingencyPlanUpdate',
            delete: 'hbContingencyPlanDelete',
            extraParam: {
              category: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
        // table模板
        // ,
        // {
        //   tabTitle: '标题',
        //   tabIndex: 'tabAA',
        //   tabType: 'table',
        //   tableNames: [
        //     '表头1',
        //     '表头2',
        //     '表头3',
        //     '表头4',
        //     '表头5',
        //     '表头6',
        //     '表头7',
        //     '表头8',
        //     '表头9'
        //   ],
        //   rowItems: [
        //     'item1',
        //     'item2',
        //     'item3',
        //     'item4',
        //     'item5',
        //     'item6',
        //     'item7',
        //     'item8',
        //     'item9'
        //   ],
        //   api: {
        //     add: 'xxxAdd',
        //     enquiry: 'xxxEnquiry',
        //     update: 'xxxUpdate',
        //     delete: 'xxxDelete',
        //     extraParam: {}
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // }
        // multiform模板,
        // {
        //   tabTitle: '标题',
        //   tabIndex: 'tabBA',
        //   tabType: 'multiform',
        //   tableNames: [
        //     '名称',
        //     '内容',
        //     '执行情况(是/否)',
        //     '备注'
        //   ],
        //   rowItems: [
        //     'name',
        //     'content',
        //     'implementation',
        //     'reason'
        //   ],
        //   editable: false,
        //   multiformData: [
        //     {
        //       name: '名称',
        //       content: '内容',
        //       editFlag: 3,
        //       options: [{}],
        //       implementation: '执行情况(是/否)',
        //       reason: '备注'
        //     }, {
        //       name: '企业性质：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }, {
        //       name: '是否属于重点排污单位：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }, {
        //       name: '是否属于实施强制性清洁生产审核的企业：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }
        //   ]
        // }
      ],
      tabDataCrt: {},
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
      }
    },
    handleRefresh () {
      console.log(this.tabType)
      this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTabData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    addRow () {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.add]({
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    editRow (row) {
      row.editFlag = true
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update](savePusher).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    }
  },
  components: {
    // ehsTableImport
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap{
  z-index: 0;
  height: 100%;
  overflow: hidden;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
